export const GEO_RESTRICTED_ACTION_MESSAGE =
  'This action is not allowed in your country'

export const PENDING_TRANSACTION_MESSAGE = 'You have a pending transaction.'
